import React from 'react';
import { ProductType } from 'types/product';

import styles from './weeklySold.module.scss';

type Props = {
  data?: ProductType;
};

export default function WeeklySold(props: Props) {
  const { sold_count_ui } = props?.data || {};

  const weekSoldCount = sold_count_ui !== '0' ? sold_count_ui : ''; // 格式化显示的周销量
  return weekSoldCount ? (
    <div data-testid="wid-product-card-weekly-sold" className={styles.weekSoldCount}>
      {sold_count_ui}
    </div>
  ) : null;
}
